import App from "#root/app";
import { createRoot } from "react-dom/client";

// Handle redirects before anything else
if (window.location.hostname === "www.cloudquote.net") {
  window.location.replace(`https://www.cloudquote.io${window.location.pathname}`);
}

const root = createRoot(document.body);

root.render(<App/>);

export { feedCollection, NewsRPMParserFeedListItemSchema } from "./schema/platform/newsrpm-parser";
export { NewsRPMMarketplaceSiteListItemSchema, siteCollection } from "./schema/platform/newsrpm-marketplace";
export { newsRPMInstanceCollection } from "./schema/platform/newsrpm-marketplace";
export { NewsRPMInstanceListItemSchema } from "./schema/platform/newsrpm-marketplace";
export { journalCollection } from "./schema/platform/newsrpm-parser";
export { NewsRPMParserJournalListItemSchema } from "./schema/platform/newsrpm-parser";
export { exchangeCollection } from "./schema/platform/reference-data";
export { ExchangeListItemSchema } from "./schema/platform/reference-data";
export { domicileCollection } from "./schema/platform/reference-data";
export { DomicileListItemSchema } from "./schema/platform/reference-data";
export { corporateActionCollection } from "./schema/platform/reference-data";
export { CorporateActionListItemSchema } from "./schema/platform/reference-data";
export { holidayCollection } from "./schema/platform/reference-data";
export { HolidayListItemSchema } from "./schema/platform/reference-data";
export { currencyCollection } from "./schema/platform/reference-data";
export { CurrencyListItemsSchema } from "./schema/platform/reference-data";